import {MutationTree} from "vuex";
import {MoreAboutWidgetState} from "@/apps/MoreAboutWidget/models/more-about-widget-state";
import AnimationService from "@/shared/services/animation-service";


export default <MutationTree<MoreAboutWidgetState>>{
    resetSubCategory(state): void {
        state.selectedSubCategory = '';
        state.subContentItems = [];
    },

    selectCategory(state, payload): void {
        state.selectedCategory = payload;
        state.subCategories = payload.subCategories;
    },

    selectSubCategory(state, payload): void {
        state.selectedSubCategory = payload.name;
        state.subContentItems = payload.contentItems;

        setTimeout(() => {
            AnimationService.rotate(".plus-minus-icon", false);
        }, 0);
    },

    closeSubCategories(state): void {
        setTimeout(() => {
            state.subCategories = [];
            state.selectedCategory = undefined;
            state.selectedSubCategory = '';
            state.subContentItems = [];
        }, 405);
    }
}
